import React, { useEffect } from "react";
import SearchBar from "../Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import H2Element from "../../Global Functions/h2Element";
import {
  changeRefundStatus,
  viewRefund,
} from "../../Redux/Actions/walletRefundAction";
import SelectInput from "../../Global Functions/selectInput";
import toast from "react-hot-toast";

const getStatusOptions = (currentStatus) => {
  switch (currentStatus) {
    case "requested":
      return [
        { label: "Select an options", value: "requested" },
        { label: "Approved", value: "approved" },
        { label: "Declined", value: "declined" },
        { label: "Completed", value: "completed" },
      ];
    case "approved":
      return [{ label: "Select an options", value: "requested" },
      { label: "Completed", value: "completed" }];
    case "declined":
    case "completed":
      return [];
    default:
      return [];
  }
};

const ViewRefunds = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(viewRefund(id));
  }, [id, dispatch]);

  const { individualRefund } = useSelector((state) => state.refunds);
  const currentStatus = individualRefund?.data?.status || "";

  const handleStatusChange = async (event) => {
    try {
      const updatedStatus = event.target.value;
      if (updatedStatus) {
        const response = await dispatch(
          changeRefundStatus({ refund_id: id, status: updatedStatus })
        );

        // Handle if dispatch returns a Promise with resolved value or a plain object
        const res = response?.payload || response;

        if (res?.statusCode === 200) {
          await dispatch(viewRefund(id));
        } else {
          toast.error(res?.message || "Failed to update status");
        }
      }
    } catch (error) {
      toast.error(error?.message || "Error updating status");
    }
  };

  return (
    <div className="overall-booking-container">
      <div className="search_booking">
        <SearchBar />
      </div>
      <div className="backicon-external">
        <Link to="/wallet_refund">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>
        <div className="backicon-internal">
          <h2 className="backicon-internal_h1">
            {individualRefund?.data?.user_id?.name || "No Data"}
          </h2>
          <div style={{ display: "flex" }}>
            <h4 className="backicon-internal_h4">
              {individualRefund?.data?.transaction_id || "No Data"}
            </h4>
          </div>
        </div>
      </div>
      <div className="overall_details">
        <h2 className="margin-20 color-white">Wallet-Refund Request Details</h2>
        <div className="top-container">
          <div className="column_project">
            <H2Element
              label="Transaction Id"
              bgBlue={true}
              value={individualRefund?.data?.transaction_id || "No Data"}
            />
            <H2Element
              label="Payment Date"
              bgBlue={true}
              value={
                individualRefund?.data?.created_at
                  ? new Date(individualRefund.data.created_at).toLocaleString()
                  : "No Data"
              }
            />
          </div>
          <hr className="project_hr" />
          <div className="column_project">
            <H2Element
              label="Amount"
              bgBlue={true}
              value={individualRefund?.data?.amount || "No Data"}
            />
            <H2Element
              label="User Name"
              value={individualRefund?.data?.user_id?.name || "No Data"}
              bgBlue={true}
            />
          </div>
          <hr className="project_hr" />
          <div className="column_project" style={{ paddingBottom: "10px" }}>
            <H2Element
              label="Status"
              value={
                currentStatus
                  ? currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1)
                  : "No Data"
              }
              bgBlue={true}
            />
            <SelectInput
              label="Select Status"
              placeholder="Select an option"
              required={false}
              onChange={handleStatusChange}
              bgBlue={true}
              options={getStatusOptions(currentStatus)}
              disabled={currentStatus === "declined" || currentStatus === "completed"}
              value={currentStatus}
            />
          </div>
        </div>
        <div>
          <h2 className="margin-20 color-white">User's Wallet Details</h2>
          <div style={{ padding: "0px 50px" }} className="top-container">
            <H2Element
              label="Account Holder's Name"
              value={
                individualRefund?.data?.user_id?.bank_detail
                  ?.account_holder_name || "No Data"
              }
              bgBlue={true}
            />
            <hr style={{ width: "0px", height: "80px" }} />
            <H2Element
              label="Bank Number"
              value={individualRefund?.data?.user_id?.bank_detail?.bank_name || "No Data"}
              bgBlue={true}
            />
            <hr style={{ width: "0px", height: "80px" }} />
            <H2Element
              label="Account Number"
              value={
                individualRefund?.data?.user_id?.bank_detail?.account_number || "No Data"
              }
              bgBlue={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewRefunds;
